
// src/layout/Topbar.tsx
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useSiteAuth } from "../hooks/useSiteAuth";

export function Topbar() {
  const { user, loggedIn, logout } = useAuth();
  const { logout: siteLogout } = useSiteAuth();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="flex items-center justify-end gap-3 px-4 py-2">
      {/* GET PRO CTA */}
      <Link
        to="/pricing"
        className="px-3 py-1.5 rounded-md bg-[#4FC3F7] text-[#0C0F14] text-sm font-semibold hover:bg-[#81D4FA] transition"
      >
        GET PRO
      </Link>

      {/* PROFILE DROPDOWN */}
      <div className="relative" ref={dropdownRef}>
        <button
          onClick={() => setOpen((prev) => !prev)}
          className="flex items-center gap-2 px-2 py-1 rounded-md hover:bg-border/20 transition"
        >
          {user?.picture ? (
            <img
              src={user.picture as string}
              alt={(user?.nickname as string) || "User"}
              className="w-6 h-6 rounded-full border border-border object-cover"
            />
          ) : (
            <span className="w-6 h-6 rounded-full bg-border block" />
          )}
          <span className="text-sm">
            {user?.nickname || (loggedIn ? "User" : "Guest")}
          </span>
        </button>

        {open && (
          <div className="absolute right-0 mt-2 w-56 rounded-md border border-border bg-surface p-2 shadow-xl animate-dropdown">
            <div className="px-2 py-1.5 text-xs text-muted">Signed in as</div>
            <div className="px-2 pb-2 text-sm font-semibold">
              {user?.nickname || (loggedIn ? "User" : "Guest")}
            </div>

            <Link
              to="/profile"
              className="block px-2 py-1.5 rounded-md text-sm hover:bg-border/20 transition"
            >
              View your profile
            </Link>

            <Link
              to="/settings"
              className="block px-2 py-1.5 rounded-md text-sm hover:bg-border/20 transition"
            >
              Settings
            </Link>

            <button
              onClick={() => void logout()}
              className="block w-full text-left px-2 py-1.5 rounded-md text-sm hover:bg-border/20 transition"
            >
              Log out of Steam
            </button>

            <button
              onClick={() => void siteLogout()}
              className="block w-full text-left px-2 py-1.5 rounded-md text-sm hover:bg-border/20 transition"
            >
              Sign out of site (Google gate)
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
